import { createContext, useContext, useState } from "react";

export const ThemeContext = createContext();
export function useTheme() {
  return useContext(ThemeContext);
}

export const DARK = {
  bg: "#131210",
  surface: "#1c1a16",
  surfaceAlt: "#242018",
  bubblePeer: "#2a2620",
  accent: "#4a6b4a",
  accentHover: "#5a7e5a",
  accentText: "#d4e8d4",
  text: "#c8c3bc",
  textSecondary: "#8a8478",
  textMuted: "#5a5650",
  border: "rgba(255,255,255,0.06)",
  borderStrong: "rgba(255,255,255,0.1)",
  input: "#131210",
  inputBorder: "rgba(255,255,255,0.08)",
  error: "rgba(160,50,50,0.2)",
  errorText: "#e89090",
  errorBorder: "rgba(160,50,50,0.3)",
  interrupt: "rgba(160,110,30,0.15)",
  interruptText: "#c8901a",
  interruptBorder: "rgba(160,110,30,0.2)",
  scrollThumb: "rgba(255,255,255,0.08)",
};

export const LIGHT = {
  bg: "#ddd7cc",
  surface: "#e6e0d4",
  surfaceAlt: "#ede8df",
  bubblePeer: "#cfc8bc",
  accent: "#4a6b4a",
  accentHover: "#3d5c3d",
  accentText: "#fff",
  text: "#2a2420",
  textSecondary: "#6b6358",
  textMuted: "#9a9288",
  border: "rgba(0,0,0,0.07)",
  borderStrong: "rgba(0,0,0,0.12)",
  input: "#ddd7cc",
  inputBorder: "rgba(0,0,0,0.09)",
  error: "rgba(140,30,30,0.1)",
  errorText: "#8b2a2a",
  errorBorder: "rgba(140,30,30,0.2)",
  interrupt: "rgba(140,90,10,0.1)",
  interruptText: "#7a4e10",
  interruptBorder: "rgba(140,90,10,0.18)",
  scrollThumb: "rgba(0,0,0,0.1)",
};

export function ThemeProvider({ children }) {
  const [isDark, setIsDark] = useState(() => {
    const saved = localStorage.getItem("turnchat-theme");
    if (saved) return saved === "dark";
    return window.matchMedia("(prefers-color-scheme: dark)").matches;
  });

  const theme = isDark ? DARK : LIGHT;

  const toggleTheme = () => {
    setIsDark((v) => {
      localStorage.setItem("turnchat-theme", !v ? "dark" : "light");
      return !v;
    });
  };

  return (
    <ThemeContext.Provider value={{ theme, isDark, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}
